import {Async, AsyncError, Pending, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {identity} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import ErrorPage from 'Shared/components/ErrorPage';
import Loading from 'Shared/components/Loading';

export const renderAsync = (asyncError: Pending | AsyncError, onLoading?: () => JSX.Element) => {
  switch (asyncError.key) {
    case 'Empty':
    case 'Loading':
      return onLoading ? onLoading() : <Loading />;
    case 'ServerError':
    case 'Unauthorized':
    case 'Conflict':
    case 'NotFound':
    default:
      return <ErrorPage error={asyncError} />;
  }
};

export const renderAsyncView = <TData extends {}>(
  asyncData: Async<TData>,
  onLoaded: (asyncData: TData) => JSX.Element,
  onLoading?: () => JSX.Element
) => {
  return pipe(
    E.right(onLoaded),
    E.ap(toEither(asyncData)),
    E.fold(error => renderAsync(error, onLoading), identity)
  );
};
